export { patientsList, patientDetail};

function patientsList(history){
  history.push("/app/patients/");
}

function patientDetail(id, history){
  history.push("/app/patients/"+id);
}